import { Spinner } from '../components/Spinner'
import { AuthLayout } from './AuthLayout'

export function BootScreen() {
  return (
    <AuthLayout>
      <div className="flex justify-center">
        <Spinner size={24} />
      </div>
    </AuthLayout>
  )
}
